module.exports = __webpack_public_path__ + "dimer/static/img/discoveryIconGroup.0b226fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discoveryIconGroup.jpg
// module id = 1b4j
// module chunks = 0